import React from "react";
import { withStyles } from "@material-ui/core/styles";
import numeral from "numeral";
import GaugeView from './GaugeView';
import Card from "./Card/Card.jsx";
import CardBody from "./Card/CardBody";
import CardHeader from "./Card/CardHeader";
import CardFooter from "./Card/CardFooter";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

const styles = theme => ({
  successText: {
    color: "#4caf50"
  },
  failureText: {
    color: "#f44336"
  },
  arrowCardCategory: {
    width: "16px",
    height: "16px"
  },
  stats: {
    color: "#999999",
    display: "inline-flex",
    fontSize: "12px",
    lineHeight: "22px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px"
    }
  },
  cardCategory: {
    color: "#999999",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0"
  },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitle: {
    color: "#3C4858",
    marginTop: "0px",
    fontSize: "30px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
});

class RankView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {
  }

  componentDidMount() {
  }

  render() {
    let { classes, label, stats } = this.props;

    let msg;
    if (stats.ranking.fromAverage > 0) {
      msg = (<span className={classes.successText}>
        <ArrowUpward className={classes.arrowCardCategory} />
        {numeral(stats.ranking.fromAverage / 100).format("0,0.00%")}
        {" "} above average
      </span>);
    }
    else {
      msg = (<span className={classes.failureText}>
        <ArrowDownward className={classes.arrowCardCategory} />
        {numeral(stats.ranking.fromAverage / 100).format("0,0.00%")}
        {" "} below average
      </span>);
    }

    return (
      <Card chart>
        <CardHeader color="success">
          <GaugeView id={`gv_${this.props.id}`} value={stats.ranking.value} targetValue={stats.ranking.targetValue} width={this.props.gaugeWidth} height={this.props.gaugeHeight} />
        </CardHeader>
        <CardBody>
          <h4 className={classes.cardTitle}>{label}</h4>
          <p className={classes.cardCategory}>
            {msg}
          </p>
        </CardBody>
        <CardFooter chart>
          <div className={classes.stats}>
            {stats.primaryMetric.value}
            {" "}
            {stats.primaryMetric.subheader}
          </div>
        </CardFooter>
      </Card>
    );
  }
}

export default withStyles(styles)(RankView);



// WEBPACK FOOTER //
// ./src/components/RankView.js